import { Component, OnInit, ViewChild } from '@angular/core';
import { StripeService } from 'src/app/services/stripe.service';
import { MatTableDataSource, MatPaginator } from '@angular/material';

@Component({
  selector: 'app-discounts',
  templateUrl: './discounts.component.html',
  styleUrls: ['./discounts.component.scss']
})
export class DiscountsComponent implements OnInit {
  public loadingCoupons:boolean=true;
  public datasource:MatTableDataSource<any>;
  displayedColumns: string[] = ['id', 'amount_off', 'percent_off', 'created', 'duration', 'name', 'valid', 'times_redeemed'];
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  constructor(
    private _stripe: StripeService
  ) { }

  public getCoupons(){
    this._stripe.getCoupons().subscribe(
      res=>{
        this.datasource = new MatTableDataSource<any>(res.data);
        this.datasource.paginator=this.paginator;
        this.loadingCoupons=false;
      }
    );
  }

  ngOnInit() {
    this.getCoupons();
  }

}
